import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { log } from 'console';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzDrawerPlacement } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'atw-config-desktop-product',
  templateUrl: './config-desktop.component.html',
  styleUrls: ['./config-desktop.component.scss']
})
export class CountDownProductConfigDesktopComponent   {
 
}
